import { GeofencesImportPage, GeofencesRoute } from './-components';
import { createFileRoute } from '@tanstack/react-router';
import { generatePath } from '@/services/router/generate-path';

function GeofencesImportRoute() {
  return (
    <GeofencesRoute
      permission="journeys/geofences/create"
      redirectTo={(params) =>
        generatePath('/workspaces/:workspaceId/geofences', { workspaceId: params.workspaceId ?? 0 })
      }
    >
      <GeofencesImportPage />
    </GeofencesRoute>
  );
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/geofences/import')({
  component: GeofencesImportRoute,
});
